module.exports = __webpack_public_path__ + "img/buddies.2925b885.png";